import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { APICallService } from 'src/app/services/api-call.service';
import { FormService } from 'src/app/services/form.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { DialogMsgComponent } from '../../common/dialog-msg/dialog-msg.component';
import { LeaveConfirmation } from '../../common/guard/check.guard';

@Component({
  selector: 'occupation-class-maintenance',
  templateUrl: './occupation-class-maintenance.component.html',
  styleUrls: ['./occupation-class-maintenance.component.css']
})
export class OccupationClassMaintenanceComponent implements OnInit, LeaveConfirmation {


  private moduleId: string = 'BMM068';
  public moduleName: string = this._jDS.data.moduleList.find((a: any) => a.moduleId === this.moduleId)?.moduleDesc?.toUpperCase() ?? "";

  constructor(
    private fb: FormBuilder,
    private _matDialog: MatDialog,
    private _api: APICallService,
    public _formService: FormService,
    private _jDS: JsonDataService,
    private _userDetailService: UserDetailsService,
    private _securityService: SecurityService
  ) { 
    this.userIdLoggedIn = this._userDetailService.userId ?? "";
  }

  ngOnInit(): void {
    this.getData.occClass();
  }

  canDeactivate(): boolean | Observable<boolean> {
    if(this.tempData!='') {
      return false;
    } else {
      return true;
    }
  }

  public btns = {
    occClass: {
      updateDisabled: true,
      deleteDisabled: true,
      saveDisabled: true,
      addDisabled: true,
    },
  }

  public selections = {
    activeTypes: [
      { cd: 'A', name: 'Yes' },
      { cd: 'I', name: 'No' },
    ]
  }

  public showForm: boolean = true;

  private rowData: any;
  private tempDataRow: any;
  private errorMessage: string = "";
  private userIdLoggedIn: string;
  private tempData: any = [];

  public forms = {
    occClassForm: this.fb.group({
      occClassCd: [null],
      occClassCdDisp: [{ value: '', disabled: 'true' }],
      occClassDesc: [null, [Validators.required, Validators.maxLength(50), this.checkDuplicateOccClassDesc(), this.noWhiteSpaceCheck()]],
      activeTag: ['A', [Validators.required]],
      bmCode: [null, [Validators.required, Validators.maxLength(8), this.noWhiteSpaceCheck()]],
      bmShortDesc: [null, [Validators.maxLength(10)]],
      remarks: [null, [Validators.maxLength(4000)]],
      userID: [{ value: '', disabled: 'true' }],
      lastUserUpdate: [{ value: '', disabled: 'true' }],
    }),
    resetOccClassForm: () => {
      this.forms.occClassForm.reset();
      this.forms.occClassForm.patchValue({
        activeTag: 'A'
      });
      this.btns.occClass.updateDisabled = this.btns.occClass.deleteDisabled = true;
      this._formService.hideFormMsg("occ-class-error-message");
      // this.rowData = null;
      // this.forms.sacForm.get('tsiAmt')?.enable();
    }
  }

  private occClassFormManipulate = {
    dbToForm: (data: any) => {
      return {
        occClassCd: data.OCCUPATION_CLASS_CD,
        occClassCdDisp: data.OCCUPATION_CLASS_CD_DISP,
        occClassDesc: data.OCCUPATION_CLASS_DESC,
        activeTag: data.ACTIVE_TAG,
        bmCode: data.BM_CODE,
        bmShortDesc: data.BM_SHORT_DESC,
        remarks: data.REMARKS,
        userID: data.USER_ID,
        lastUserUpdate: data.LAST_UPDATE,
      };
    },
    formToDb: (data: any, mode: any) => {
      return {
        OCCUPATION_CLASS_CD: data.occClassCd,
        OCCUPATION_CLASS_CD_DISP: data.occClassCd?.toString().padStart(2, 0) ?? null,
        OCCUPATION_CLASS_DESC: data.occClassDesc.trim(),
        ACTIVE_TAG: data.activeTag,
        BM_CODE: data.bmCode,
        BM_SHORT_DESC: data.bmShortDesc,
        REMARKS: data.remarks,
        USER_ID: this.userIdLoggedIn,
        LAST_UPDATE: null,
        MODE: mode
      };
    },
  }

  public occClassTblConfig = {
    cols: [
      {
        key: "OCCUPATION_CLASS_CD_DISP",
        header: "Occupation Class Code",
        dataType: "string",
        width: '25%'
      },
      {
        key: "OCCUPATION_CLASS_DESC",
        header: "Occupation Class",
        dataType: "string"
      },
      {
        key: "ACTIVE_TAG",
        header: "A",
        dataType: "checkbox",
        width: '64px'
      }
    ],
    tblData: [] as any[],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  }

  private getData = {
    occClass: () => {
      try {
        this.occClassTblConfig.tblData = [];
        this.occClassTblConfig.loading = true;
        this._jDS.contorlLoading(true);
        this._api.getOccupationClass({
          moduleId: this.moduleId,
          userId: this._userDetailService.userId,
          type: "MODULE"
        }).subscribe({
          next: (data: any) => {
            this._securityService.checkRequestKeyResponse(data, () => {
              this._securityService.hasValidCsrfToken(data, () => {
                let content = JSON.parse(this._jDS.decrypt(data.response));
                this._jDS.contorlLoading(false);
                this.occClassTblConfig.tblData = content.data;
                this.btns.occClass.addDisabled = false;
                this.occClassTblConfig.loading = false;
              });
            });
          },
          error: (error: any) => {
            this.occClassTblConfig.loading = false;
            this._jDS.contorlLoading(false);
          }
        });
      }
      catch (e) {
        console.error(e);
      }
    }
  }

  public onRowClick(ev: any) {
    try {
      ev.update = true;
      this.rowData = ev;
      this.populateFormFromTable();
    }
    catch (e) {
      this.forms.resetOccClassForm();
      this.rowData = null;
      //this.indexRow = null;
    }
  }

  private populateFormFromTable() {
    try {
      let data = this.rowData;
      this.btns.occClass.updateDisabled = !data.update;
      this.btns.occClass.deleteDisabled = !data.temp;
      this.tempDataRow = !data.temp;
      this.forms.occClassForm.patchValue(this.occClassFormManipulate.dbToForm(data));
    }
    catch (e) {
      console.error(e);
    }
  }

  public onAdd() {
    try {
      this._formService.hideFormMsg("occ-class-error-message");
      if (this.forms.occClassForm.valid) {
        let rowToBeAdded: { [key: string]: any } = this.occClassFormManipulate.formToDb(this.forms.occClassForm.value, 'I');
        rowToBeAdded.temp = true;
        this.tempData.push(rowToBeAdded);
        this.occClassTblConfig.tblData = [rowToBeAdded, ...this.occClassTblConfig.tblData];

        this.forms.resetOccClassForm();
        this.btns.occClass.saveDisabled = false;
      }
      else {
        this.showErrorValidator.occClass();
      }
    }
    catch (e) {
      console.error(e);
    }
  }

  public onDelete() {
    try {
      let clickData = this.rowData;
      this.occClassTblConfig.tblData = this.occClassTblConfig.tblData.filter((d: any) => {
        return d !== this.rowData;
      });
      this.tempData = this.tempData.filter(
        function(e: any) {
          return e.OCCUPATION_CLASS_DESC != clickData.OCCUPATION_CLASS_DESC;
        }
      );
      this.forms.resetOccClassForm();
    }
    catch (e) {
      console.error(e);
    }
  }

  public onUpdate() {
    try {
      this._formService.hideFormMsg("occ-class-error-message");
      
      if (this.forms.occClassForm.valid) {
        let clickData = this.rowData;
        let toBeUpdatedIndex = this.occClassTblConfig.tblData.indexOf(this.rowData);
        let occClassCdRowValue = this.rowData.OCCUPATION_CLASS_CD;
        let rowToBeUpdated: { [key: string]: any } = this.occClassFormManipulate.formToDb(this.forms.occClassForm.value, 'U');
        let tempInsertChecker = this.tempData.find(
          (m: { OCCUPATION_CLASS_DESC: any; }) => m.OCCUPATION_CLASS_DESC == clickData.OCCUPATION_CLASS_DESC && clickData.MODE == 'I');
        let tempUpdateChecker = this.tempData.find(
          (m: { OCCUPATION_CLASS_DESC: any; }) => m.OCCUPATION_CLASS_DESC == clickData.OCCUPATION_CLASS_DESC && clickData.MODE == 'U');
        if (this.rowData.temp) {
          rowToBeUpdated.temp = true;
        }
        else {
          rowToBeUpdated.onDbButUpdatedTemp = true;
          rowToBeUpdated.OCCUPATION_CLASS_CD = occClassCdRowValue;
        }

        if (tempInsertChecker!=null && tempInsertChecker!='') {
          //tempInsertChecker = rowToBeUpdated;
          tempInsertChecker.OCCUPATION_CLASS_DESC = rowToBeUpdated.OCCUPATION_CLASS_DESC;
          tempInsertChecker.ACTIVE_TAG = rowToBeUpdated.ACTIVE_TAG;
          tempInsertChecker.BM_CODE = rowToBeUpdated.BM_CODE;
          tempInsertChecker.BM_SHORT_DESC = rowToBeUpdated.BM_SHORT_DESC;
          tempInsertChecker.REMARKS = rowToBeUpdated.REMARKS;
          tempInsertChecker.USER_ID = rowToBeUpdated.USER_ID;
          tempInsertChecker.MODE = 'I';
          rowToBeUpdated.MODE = 'I';
        }
        else if (tempUpdateChecker!=null && tempUpdateChecker!='') {
          tempUpdateChecker.OCCUPATION_CLASS_DESC = rowToBeUpdated.OCCUPATION_CLASS_DESC;
          tempUpdateChecker.ACTIVE_TAG = rowToBeUpdated.ACTIVE_TAG;
          tempUpdateChecker.BM_CODE = rowToBeUpdated.BM_CODE;
          tempUpdateChecker.BM_SHORT_DESC = rowToBeUpdated.BM_SHORT_DESC;
          tempUpdateChecker.REMARKS = rowToBeUpdated.REMARKS;
          tempUpdateChecker.USER_ID = rowToBeUpdated.USER_ID;
          tempUpdateChecker.MODE = 'U';
        }
        else { 
          this.tempData.push(rowToBeUpdated);
        }
        this.forms.resetOccClassForm();
        this.occClassTblConfig.tblData[toBeUpdatedIndex] = rowToBeUpdated;
        this.btns.occClass.saveDisabled = false;
        this.occClassTblConfig.tblData = [... this.occClassTblConfig.tblData];
      }
      else {
        this.showErrorValidator.occClass();
      }
    }
    catch (e) {
      console.error(e);
    }
  }

  public onSave() {
    try {
      this.btns.occClass.saveDisabled = true;
      this.showForm = false;
      this._formService.showFormLoader(null, "occ-class-maintenance-loading", "Saving.<br>Please wait ...", null, null);
      if (this.tempData.length > 0) {
        this._api.saveOccupationClass(this.tempData).subscribe({
          next: (data: any) => {
            this._securityService.checkRequestKeyResponse(data, () => {
              this._securityService.hasValidCsrfToken(data, () => {
                if (data.status === 'SUCCESS') {
                  this.onComplete.occClass();
                }
                else {
                  this.onComplete.occClassError();
                }
              });
            });
          },
          error: (data: any) => {
            this.onComplete.occClassError();
          },
        });
      }
      else
        this.onComplete.occClass();
    }
    catch (e) {
      console.error(e);
    }
  }

  private onComplete = {
    occClass: () => {
      this.tempData = [];
      this.getData.occClass();
      this.btns.occClass.saveDisabled = true;
      this.showForm = true;
      this._formService.hideFormLoader("occ-class-maintenance-loading");
      this.forms.resetOccClassForm();
      this.openDialog('SUCCESS', 'Occupation Class details successfully saved');
    },
    occClassError: () => {
      this.showForm = true;
      this.btns.occClass.saveDisabled = false;
      this.openDialog('FAILED', 'Occupation Class details saving failed');
      this._formService.hideFormLoader("occ-class-maintenance-loading");
    },
  }

  openDialog(title: any, message: any) {
    try {
      this.showForm = true;
      this._formService.hideFormLoader("occ-class-maintenance-loading");
      this._matDialog.open(DialogMsgComponent, { 
        disableClose: true,
        width: "500px",
        data: {
          title: title,
          content: message
        } 
      });
    } catch(e) {
      console.error(e);
    }
  }

  noWhiteSpaceCheck(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { whitespace: true };
    }
  }

  checkDuplicateOccClassDesc(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value?.trim()?.toUpperCase();
      if (!value) return null;
      let hasDuplicate: boolean = this.occClassTblConfig.tblData.filter((d: any) => {
        if (!this.rowData && this.btns.occClass.updateDisabled)
          return d.OCCUPATION_CLASS_DESC.toUpperCase() === value;
        else
          return this.rowData.OCCUPATION_CLASS_DESC.trim().toUpperCase() !== value && d.OCCUPATION_CLASS_DESC.trim().toUpperCase() === value;
      }).length > 0 ? true : false;
      return hasDuplicate ? { hasDupe: true } : null;
    }
  }

  public showErrorValidator = {
    occClass: () => {
      try {
        Object.keys(this.forms.occClassForm.controls).forEach(key => {
          const controlErrors = this.forms.occClassForm.get(key)?.errors;
          if (controlErrors != null) {
            Object.keys(controlErrors).forEach(keyError => {
              if (keyError == 'whitespace' && controlErrors[keyError] === true)
                this.errorMessage = "There are missing information. Please provide necessary information needed.";
              else if (keyError == 'hasDupe' && controlErrors[keyError] === true)
                this.errorMessage = "Occupation Class already exists. Please add a unique Occupation Class.";
              else if (keyError == 'required' && controlErrors[keyError] === true)
                this.errorMessage = "There are missing information. Please provide necessary information needed.";
            });
          }
        });
        this._formService.showFormMsg("occ-class-error-message", this.errorMessage, "E");
        //this.openDialog('ERROR', this.errorMessage);
        setTimeout(()=>{                           
          this._formService.hideFormMsg("occ-class-error-message");
        }, 10000);
      }
      catch (e) {
        console.error(e);
      }
    },
  }

}
